import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { FC } from "react";
import VccMap from "../../map/vcc-map";

interface EventLocationPointModalProps {
  props: {
    isOpen: boolean;
    initialLngLat?: { lng: number; lat: number };
    onCancel: () => void;
    onConfirm: (newLongitude: number, newLatitude: number) => void;
  };
}

const EventLocationPointModal: FC<EventLocationPointModalProps> = ({ props }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClose = (event?: object, reason?: string) => {
    if (reason === "backdropClick") return false;
    props.onCancel();
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={props.isOpen}
      onClose={handleClose}
      fullWidth
      maxWidth="xl"
      aria-labelledby="form-dialog-title"
    >
      <IconButton
        onClick={props.onCancel}
        size="large"
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogTitle id="form-dialog-title">Event Location</DialogTitle>

      <DialogContent>
        <VccMap
          props={{
            // Required props that don't apply to this scenario
            markerData: [],
            initLayers: [],
            initMarkerSets: [],
            allAvailableLayers: [],
            allAvailableMarkerSets: [],
            showAnnotateTools: false,
            markerOnClick: () => {
              return;
            },
            // Props specific to setting event location
            isEditMajorEventLocation: true,
            eventInitialLngLat: props.initialLngLat
              ? {
                  lng: props.initialLngLat.lng,
                  lat: props.initialLngLat.lat,
                }
              : undefined,
            onMajorEventLocationCancellation: () => {
              console.log("modal cancel callback");
              props.onCancel();
            },
            onMajorEventLocationConfirmation: (longitude: number, latitude: number) => {
              console.log("modal confirm callback", longitude, latitude);
              props.onConfirm(longitude, latitude);
            },
          }}
        />
      </DialogContent>

      {/* No actions or buttons, because panel on map has cancel button with call back set to props.onCancel() above. */}
    </Dialog>
  );
};

export default EventLocationPointModal;
